var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4835 9.90336C12.9324 9.78777 12.4965 10.0373 12.1105 10.2551C11.7152 10.4797 10.9636 11.0743 10.5327 10.9221C8.32683 10.0364 6.25216 8.15363 5.35407 5.9939C5.19578 5.56478 5.80269 4.82713 6.03124 4.4371C6.25301 4.05954 6.50356 3.63042 6.38929 3.08904C6.28602 2.60254 4.95031 0.94511 4.47798 0.491875C4.16649 0.19249 3.84737 0.0278285 3.51979 0.00121652C2.28819 -0.0503442 0.912698 1.5522 0.671457 1.93557C0.067085 2.75306 0.0704708 3.84082 0.681614 5.15978C2.15445 8.7025 7.725 14.049 11.3715 15.5393C12.0445 15.8462 12.6599 16 13.2126 16C13.7535 16 14.2351 15.8528 14.649 15.5609C14.9614 15.3854 16.6721 13.9775 16.6272 12.7442C16.6001 12.4298 16.4317 12.1155 16.1286 11.8111C15.6673 11.3462 13.9786 10.0048 13.4835 9.90336",
    fill: "#8A9099"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconGray);
export default __webpack_public_path__ + "static/media/phone-icon-gray.397b079ad998d5b6c8bb69afb1a334e9.svg";
export { ForwardRef as ReactComponent };